
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/pasm-capacity-planning",
      function () {
        return require("private-next-pages/solutions/pasm-capacity-planning/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/pasm-capacity-planning"])
      });
    }
  